import { GoBack } from "@/components/shared/layout"

const TermsPage = () => {
  const searchParams = new URLSearchParams(window.location.search)
  const isViewMode = searchParams.get("mode") === "view"

  return (
    <div className="flex flex-col h-full bg-white">
      {/* Header */}
      {!isViewMode && (
        <div className="sticky top-0 z-50">
          <GoBack title="Quay về" className="bg-white" />
        </div>
      )}

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-4">
        {/* Header */}
        <div className="text-center mb-10 border-b pb-6">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-primary text-center mb-2 leading-tight">
            ĐIỀU KHOẢN SỬ DỤNG (TERMS OF SERVICE)
          </h1>
          <p className="text-gray-500 italic font-medium">
            Điều Khoản Sử Dụng này được cập nhật gần nhất vào ngày 01/11/2025.
          </p>
        </div>

        {/* Introduction Box */}
        <div className="mb-8 p-4 bg-blue-50 border-l-4 border-blue-500 rounded-r text-gray-700 italic">
          <p>
            Chào mừng Quý Đối Tác đến với ứng dụng <strong>ZZP</strong> (“
            <strong>Ứng Dụng</strong>”), vui lòng đọc kỹ nội dung của Điều Khoản Sử Dụng này trước
            khi Quý Đối Tác thực hiện các thao tác, giao dịch trên Ứng Dụng. Điều Khoản Sử Dụng này
            sẽ điều chỉnh việc Quý Đối Tác truy cập và thực hiện các thao tác, giao dịch trên Ứng
            Dụng. Bằng cách truy cập vào Ứng Dụng và/hoặc sử dụng các tính năng trên Ứng Dụng, Quý
            Đối Tác thừa nhận rằng đã đọc, hiểu và chịu sự ràng buộc bởi các quy định tại Điều Khoản
            Sử Dụng này, qua đó cấu thành một thỏa thuận pháp lý giữa Quý Đối Tác và{" "}
            <strong>CÔNG TY CỔ PHẦN ALPHA SPACEZ</strong> (sau đây gọi là “
            <strong>ALPHA SPACEZ</strong>”) - Chủ sở hữu Ứng Dụng. Nếu Quý Đối Tác không đồng ý với
            bất cứ nội dung nào của Điều Khoản Sử Dụng này, vui lòng không truy cập và/hoặc thao
            tác, giao dịch trên Ứng Dụng hoặc sử dụng bất kỳ tính năng nào được cung cấp trên Ứng
            Dụng.
          </p>
        </div>

        {/* Section 1 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">
            1. ĐỊNH NGHĨA VÀ GIẢI THÍCH
          </h2>
          <p>
            Trừ khi được định nghĩa khác đi, các định nghĩa và diễn giải được nêu trong Phụ Đính 1
            sẽ được áp dụng cho Điều Khoản Sử Dụng này.
          </p>
        </section>

        {/* Section 2 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">
            2. ĐIỀU KHOẢN CHUNG VỀ SỬ DỤNG DỊCH VỤ VÀ/HOẶC TRUY CẬP ỨNG DỤNG
          </h2>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">2.1 Hướng Dẫn Sử Dụng Ứng Dụng</h3>
          <div className="pl-4 md:pl-8 space-y-2 mb-4 text-gray-700">
            <p>
              (a) ALPHA SPACEZ cấp quyền cho Quý Đối Tác sử dụng và truy cập vào Ứng Dụng để sử dụng
              các tính năng được cung cấp trên Ứng Dụng theo các điều khoản và điều kiện cụ thể được
              quy định tại Phụ Đính 2.
            </p>
            <p>
              (b) Quý Đối Tác đồng ý tuân thủ bất kỳ và tất cả các hướng dẫn, thông báo, quy chế
              hoạt động và chính sách cũng như hướng dẫn (nếu có) liên quan đến việc truy cập vào
              Ứng Dụng và sử dụng các tính năng trên Ứng Dụng, cũng như bất kỳ điều chỉnh nào đối
              với những quy định đề cập trên đây do ALPHA SPACEZ ban hành vào từng thời điểm. ALPHA
              SPACEZ có quyền sửa đổi các hướng dẫn, thông báo, quy chế và chính sách hoạt động và
              hướng dẫn này vào bất kỳ lúc nào với thông báo trước phù hợp với quy định pháp luật và
              Quý Đối Tác được xem là đã biết và chịu sự ràng buộc bởi bất kỳ thay đổi nào như vậy
              kể từ khi những thông báo thay đổi, bổ sung được đăng tải trên Ứng Dụng.
            </p>
          </div>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">2.2 Các Hoạt Động Bị Giới Hạn</h3>
          <p className="mb-2">
            Quý Đối Tác đồng ý và cam kết <strong>KHÔNG</strong>:
          </p>
          <div className="pl-4 md:pl-8 space-y-2 mb-4 text-gray-700">
            <p>
              (a) mạo danh bất kỳ cá nhân hoặc tổ chức nào hoặc tuyên bố không đúng sự thật hoặc gây
              nhầm lẫn về mối quan hệ của Quý Đối Tác với bất kỳ cá nhân hoặc tổ chức nào;
            </p>
            <p>
              (b) sử dụng Ứng Dụng cho các mục đích bất hợp pháp; không hợp lý, lừa đảo, đe doạ,
              thăm dò thông tin bất hợp pháp, phá hoại, tạo ra và phát tán virus gây hư hại tới hệ
              thống, cấu hình, truyền tải thông tin của Ứng Dụng hay sử dụng các tính năng, tiện ích
              trên Ứng Dụng vào mục đích đầu cơ, lũng đoạn thị trường, tạo những đơn đặt hàng, chào
              hàng giả, kể cả phục vụ cho việc phán đoán nhu cầu thị trường;
            </p>
            <p>
              (c) cố tình truy cập trái phép hoặc can thiệp hoặc làm gián đoạn hệ thống máy tính
              hoặc hệ thống mạng được kết nối với Ứng Dụng;
            </p>
            <p>(d) đăng tải, quảng cáo hoặc truyền tải qua Ứng Dụng bất kỳ Tài Liệu Bị Cấm nào;</p>
            <p>(e) can thiệp vào việc sử dụng Ứng Dụng của người khác;</p>
            <p>
              (f) sử dụng hoặc đăng tải bất kỳ phần mềm hoặc tài liệu, theo bất kỳ cách thức nào mà
              Quý Đối Tác có lý do để nghi ngờ rằng những phần mềm hoặc tài liệu này có chứa vi rút,
              các yếu tố gây hỏng hóc, mã độc hại hoặc các thành phần có hại khác mà có thể làm suy
              yếu hoặc làm hỏng dữ liệu trên Ứng Dụng hoặc làm hỏng hoặc can thiệp vào máy tính hoặc
              thiết bị di động của người dùng khác;
            </p>
            <p>
              (g) sử dụng Ứng Dụng không tuân theo chính sách sử dụng được cho phép của bất kỳ mạng
              máy tính có kết nối, bất kỳ tiêu chuẩn sử dụng mạng Internet và bất kỳ quy định pháp
              luật hiện hành nào được áp dụng;
            </p>
            <p>
              (h) thay đổi, chỉnh sửa, sao chép, truyền bá, phân phối, cung cấp và tạo những công
              cụ, tính năng tương tự Ứng Dụng cho một bên thứ ba mà không được sự đồng ý của ALPHA
              SPACEZ; và
            </p>
            <p>
              (i) hành động gây mất uy tín của ALPHA SPACEZ và/hoặc Ứng Dụng dưới mọi hình thức.
            </p>
          </div>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">2.3 Tính Sẵn Có Của Ứng Dụng</h3>
          <p>
            Quý Đối Tác đồng ý rằng ALPHA SPACEZ có thể, tùy từng thời điểm, tiến hành nâng cấp, sửa
            đổi, tạm ngưng hoặc ngừng cung cấp hoặc xóa bỏ, toàn bộ hoặc một phần tính năng trên Ứng
            Dụng phù hợp với quy định của pháp luật.
          </p>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">
            2.4 Khả Năng Tương Thích Trên Ứng Dụng
          </h3>
          <p>
            Các phiên bản định tuyến, trình duyệt và thiết bị có thể có phần cứng hoặc chế độ cài
            đặt không tương thích với Ứng Dụng. Mặc dù ALPHA SPACEZ liên tục phát triển Ứng Dụng
            trong phạm vi tối đa có thể nhằm hỗ trợ tất cả các thiết bị và phiên bản được sử dụng
            phổ biến trên thị trường và tất cả các trình duyệt mà có thể truy cập được vào Ứng Dụng,
            ALPHA SPACEZ không đảm bảo khả năng tương thích của các thiết bị di động chuyên biệt
            hoặc phần cứng chuyên biệt khác trên Ứng Dụng.
          </p>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">
            2.5 Quyền, Nhưng Không Phải Nghĩa Vụ Về Điều Chỉnh Nội Dung trên Ứng Dụng
          </h3>
          <p className="mb-2">ALPHA SPACEZ bảo lưu quyền được thực hiện:</p>
          <div className="pl-4 md:pl-8 space-y-2 mb-4 text-gray-700">
            <p>
              (a) giám sát, sàng lọc hoặc kiểm soát bất kỳ hoạt động, nội dung hoặc tài liệu trên
              Ứng Dụng. ALPHA SPACEZ có toàn quyền quyết định về việc tiến hành điều tra bất kỳ vi
              phạm nào đối với Điều Khoản Sử Dụng và có quyền thực hiện bất kỳ hành động nào mà
              ALPHA SPACEZ cho là phù hợp;
            </p>
            <p>
              (b) ngăn chặn hoặc hạn chế quyền truy cập của bất kỳ người dùng nào không tuân thủ
              (theo toàn quyền quyết định của ALPHA SPACEZ) đối với Ứng Dụng;
            </p>
            <p>
              (c) báo cáo bất kỳ hoạt động nào mà ALPHA SPACEZ có cơ sở để nghi ngờ là vi phạm quy
              định pháp luật hoặc theo quy định của cơ quan chức năng và để hợp tác với cơ quan chức
              năng; và/hoặc;
            </p>
            <p>
              (d) yêu cầu Quý Đối Tác cung cấp bất kỳ thông tin và dữ liệu nào có liên quan đến việc
              sử dụng và/hoặc truy cập vào Ứng Dụng vào bất kỳ thời gian nào; và để thực hiện quyền
              của ALPHA SPACEZ theo điều khoản này nếu Quý Đối Tác từ chối tiết lộ thông tin và/hoặc
              dữ liệu đó; hoặc nếu ALPHA SPACEZ có cơ sở hợp lý để nghi ngờ Quý Đối Tác đã cung cấp
              thông tin và/hoặc dữ liệu không chính xác, gây hiểu nhầm hoặc gian lận.
            </p>
          </div>
        </section>

        {/* Section 3 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">3. SỬ DỤNG DỊCH VỤ</h2>
          <p className="mb-2">
            3.1 Hạn Chế: Quý Đối Tác đã vi phạm hoặc có hành vi vi phạm các điều khoản và điều kiện
            quy định tại Điều Khoản Sử Dụng này và Quý Đối Tác đã bị đình chỉ tạm thời hoặc vĩnh
            viễn việc sử dụng bất kỳ tính năng nào của Ứng Dụng thì Quý Đối Tác sẽ không được sử
            dụng Ứng Dụng ngay cả khi đã đáp ứng các yêu cầu của Điều 3.2 dưới đây.
          </p>
          <p className="mb-2">3.2 Điều Khoản Sử Dụng Chung: Quý Đối Tác đồng ý:</p>
          <div className="pl-4 md:pl-8 space-y-2 mb-4 text-gray-700">
            <p>
              (a) thực hiện bất kỳ hoạt động liên quan đến việc sử dụng Ứng Dụng một cách trung thực
              và hợp pháp; và
            </p>
            <p>
              (b) đảm bảo rằng bất kỳ thông tin hoặc dữ liệu được Quý Đối Tác đăng tải hoặc tạo ra
              trên Ứng Dụng hoặc cung cấp cho ALPHA SPACEZ là chính xác và Quý Đối Tác đồng ý chịu
              toàn bộ trách nhiệm về thông tin và dữ liệu đó.
            </p>
          </div>
          <p>
            ALPHA SPACEZ có thể hủy bỏ hoặc từ chối cho phép Quý Đối Tác sử dụng bất kỳ tính năng
            nào của Ứng Dụng khi ALPHA SPACEZ cho rằng hoặc có cơ sở để nghi ngờ rằng Quý Đối Tác đã
            sử dụng Ứng Dụng theo cách thức không phù hợp hoặc gian lận. Để tránh nhầm lẫn, việc sử
            dụng Ứng Dụng một cách không phù hợp hoặc gian lận bao gồm hành vi lạm dụng khuyến mại
            và/hoặc hoạt động gian lận trên Ứng Dụng.
          </p>
        </section>

        {/* Section 4 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">
            4. QUÝ ĐỐI TÁC SỞ HỮU TÀI KHOẢN NGƯỜI DÙNG
          </h2>
          <h3 className="font-bold text-gray-800 mt-4 mb-2">4.1 Tên Người Dùng/Mật Khẩu</h3>
          <p className="mb-2">
            Để sử dụng Ứng Dụng và các tính năng trên Ứng Dụng ALPHA SPACEZ yêu cầu Quý Đối Tác phải
            tạo Tài Khoản Người Dùng và/hoặc yêu cầu Quý Đối Tác cung cấp Dữ Liệu Cá Nhân. Đối với
            Tài Khoản Người Dùng, Tên Người Dùng và Mật Khẩu có thể là:
          </p>
          <div className="pl-4 md:pl-8 space-y-2 mb-4 text-gray-700">
            <p>(a) do ALPHA SPACEZ xác định và cấp cho Quý Đối Tác; hoặc</p>
            <p>
              (b) do Quý Đối Tác cung cấp và được ALPHA SPACEZ chấp nhận theo toàn quyền quyết định
              của ALPHA SPACEZ về việc sử dụng và/hoặc truy cập vào Ứng Dụng. ALPHA SPACEZ có quyền,
              vào bất kỳ thời điểm nào, yêu cầu Quý Đối Tác cập nhật Dữ Liệu Cá Nhân hoặc hủy bỏ
              ngay lập tức hiệu lực của Tài Khoản Người Dùng và sẽ không chịu trách nhiệm pháp lý
              đối với bất kỳ Tổn Thất nào mà Quý Đối Tác phải chịu hoặc do Quý Đối Tác gây ra hoặc
              vì bất kỳ lý do nào liên quan đến yêu cầu hoặc sự hủy bỏ của ALPHA SPACEZ. Quý Đối Tác
              đồng ý thay đổi Mật Khẩu vào từng thời điểm và giữ bí mật Tên Người Dùng và Mật Khẩu,
              cũng như bảo mật Tài Khoản Người Dùng của Quý Đối Tác và tự chịu trách nhiệm về việc
              tiết lộ hoặc sử dụng Tên Người Dùng và/hoặc Mật Khẩu (cho dù việc sử dụng đó có được
              phép hay không). Quý Đối Tác phải thông báo ngay lập tức cho ALPHA SPACEZ nếu Quý Đối
              Tác biết rằng hoặc có lý do để nghi ngờ tính bảo mật của Tên Người Dùng và/hoặc Mật
              Khẩu đã bị xâm phạm hoặc Tên Người Dùng và/hoặc Mật Khẩu đã bị sử dụng trái phép hoặc
              nếu có yêu cầu cập nhập Dữ Liệu Cá Nhân của Quý Đối Tác.
            </p>
            <p>
              (c) Quý Đối Tác có thể nhận thư điện tử khuyến mại, tin nhắn văn bản SMS và/hoặc tin
              nhắn tại ứng dụng hoặc thông báo từ ALPHA SPACEZ theo cách thức phù hợp với chính sách
              của ALPHA SPACEZ và quy định pháp luật áp dụng. Trong trường hợp Quý Đối Tác không
              muốn tiếp tục nhận các thông báo như vậy, Quý Đối Tác có quyền từ chối bằng cách nhấp
              vào liên kết hiển thị ở cuối thông báo (nếu có) hoặc gửi email cho ALPHA SPACEZ:{" "}
              <a href="mailto:support@zzp.vn" className="text-blue-600 hover:underline">
                support@zzp.vn
              </a>
              .
            </p>
          </div>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">4.2 Mục Đích Sử Dụng/Truy Cập</h3>
          <p className="mb-2">
            Quý Đối Tác đồng ý và thừa nhận rằng việc sử dụng và/hoặc truy cập vào Ứng Dụng và mọi
            thông tin, dữ liệu hoặc thông tin liên lạc được khởi tạo từ Tài Khoản Người Dùng của Quý
            Đối Tác được xem là, theo từng trường hợp:
          </p>
          <div className="pl-4 md:pl-8 space-y-2 mb-4 text-gray-700">
            <p>(a) do Quý Đối Tác truy cập vào và/hoặc sử dụng Ứng Dụng; hoặc</p>
            <p>
              (b) do Quý Đối Tác đăng tải, truyền gửi và công bố thông tin, dữ liệu hoặc thông tin
              liên lạc một cách hợp lệ. Quý Đối Tác sẽ chịu sự ràng buộc khi truy cập vào Ứng Dụng
              và/hoặc sử dụng bất kỳ tính năng nào trên Ứng Dụng từ Tài Khoản Người Dùng của Quý Đối
              Tác (cho dù lượt truy cập hoặc sử dụng Ứng Dụng đó có được Quý Đối Tác cho phép hay
              không) và ALPHA SPACEZ có quyền (nhưng không có nghĩa vụ) hành động, phản hồi hoặc giữ
              cho Quý Đối Tác chịu toàn bộ trách nhiệm đối với những hành động đăng tải, chuyển phát
              và công bố thông tin, dữ liệu hoặc thông tin liên lạc như thể những hành động này do
              chính Quý Đối Tác thực hiện. Quý Đối Tác sẽ bồi thường bất kỳ và toàn bộ Tổn Thất cho
              ALPHA SPACEZ nếu ALPHA SPACEZ có bất kỳ Tổn Thất nào phát sinh liên quan đến việc sử
              dụng Tài Khoản Người Dùng của Quý Đối Tác.
            </p>
          </div>
        </section>

        {/* Section 5 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">
            5. QUYỀN SỞ HỮU TRÍ TUỆ
          </h2>
          <h3 className="font-bold text-gray-800 mt-4 mb-2">5.1 Quyền Sở Hữu:</h3>
          <div className="pl-4 md:pl-8 space-y-2 mb-4 text-gray-700">
            <p>
              (a) ALPHA SPACEZ sở hữu, cấp phép và kiểm soát toàn bộ Tài Sản Sở Hữu Trí Tuệ trên Ứng
              Dụng và toàn bộ Tài Liệu trên Ứng Dụng. ALPHA SPACEZ bảo lưu quyền thực thi liên quan
              đến Quyền Sở Hữu Trí Tuệ của mình trong phạm vi tối đa pháp luật cho phép.
            </p>
            <p>
              (b) ALPHA SPACEZ là chủ sở hữu của tất cả sản phẩm sáng tạo do Quý Đối Tác sáng tạo và
              thực hiện theo các thỏa thuận giữa ALPHA SPACEZ và Quý Đối Tác; hoặc theo các công
              việc, dịch vụ mà Quý Đối Tác cung cấp cho ALPHA SPACEZ theo các điều khoản và điều
              kiện được đăng tải trên Ứng Dụng. Tuy nhiên đối với các nội dung có xuất hiện hình ảnh
              cá nhân của Quý Đối Tác thì ALPHA SPACEZ chỉ sử dụng trong thời hạn đã thỏa thuận với
              Quý Đối Tác hoặc theo điều khoản và điều kiện được đăng tải trên Ứng Dụng. Để làm rõ,
              sau khi hết thời gian sử dụng hình ảnh của Quý Đối Tác (nếu có), đối với tất cả các
              sản phẩm sáng tạo do Quý Đối Tác thực hiện mà đã phát hành trên nền tảng trực tuyến
              (online) như mạng xã hội, các kênh truyền thông trên internet, dù có hoặc không có
              xuất hiện hình ảnh của Quý Đối Tác, bao gồm nhưng không giới hạn đoạn phim, hình ảnh,
              giọng hát, âm thanh, footage thì ALPHA SPACEZ không phải tháo bỏ trên các kênh đã đăng
              tải, phát hành. Để làm rõ, nếu các bên không có nội dung thỏa thuận nào đề cập đến các
              hạn chê về quyền sử dụng hình ảnh hoặc sản phẩm sáng tạo do Quý Đối Tác thực hiện thì
              ALPHA SPACEZ được quyền sử dụng các sản phẩm sáng tạo này không xác định thời hạn.
            </p>
          </div>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">5.2 Hạn Chế Sử Dụng:</h3>
          <p>
            Không có bất kỳ nội dung nào trên Ứng Dụng, hoặc bất kỳ Tài Liệu nào được làm lại, thiết
            kế lại, tách rời, thay đổi, phân phối, tái xuất bản, hiển thị lại, phát sóng, sao chép,
            làm mẫu, chuyển giao hoặc truyền tải lại theo bất kỳ cách thức nào hoặc bằng bất kỳ
            phương tiện nào hoặc được lưu trữ trong hệ thống thông tin hoặc được cài đặt trên bất kỳ
            hệ thống máy chủ, hệ thống hoặc thiết bị nào mà không được sự cho phép trước bằng văn
            bản của ALPHA SPACEZ hoặc của chủ sở hữu bản quyền có liên quan. Phụ thuộc vào Mục 5.3
            dưới đây, Quý Đối Tác chỉ được ALPHA SPACEZ cho phép tải xuống, in hoặc sử dụng Tài Liệu
            cho mục đích cá nhân và phi thương mại, với điều kiện Quý Đối Tác không được sửa đổi nội
            dung Tài Liệu và ALPHA SPACEZ hoặc các chủ sở hữu bản quyền có liên quan vẫn giữ tất cả
            bản quyền và các thông báo của chủ sở hữu quy định trong Tài Liệu.
          </p>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">5.3 Nhãn Hiệu:</h3>
          <p>
            Không có bất kỳ thông tin nào trên Ứng Dụng và trong Điều Khoản Sử Dụng này sẽ được hiểu
            là cho phép, dù rõ ràng hoặc ngụ ý, ám chỉ hoặc được hiểu theo bất kỳ cách nào khác rằng
            Quý Đối Tác có quyền sử dụng bất kỳ giấy phép hoặc có quyền sử dụng (bao gồm dưới dạng
            thẻ meta hoặc đường dẫn liên kết đến một website/ứng dụng khác) bất kỳ Nhãn Hiệu nào
            được hiển thị trên Ứng Dụng mà không có sự cho phép bằng văn bản của ALPHA SPACEZ hoặc
            bất kỳ chủ sở hữu Nhãn Hiệu nào khác.
          </p>
        </section>

        {/* Section 6 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">
            6. THÔNG TIN QUÝ ĐỐI TÁC CUNG CẤP CHO ALPHA SPACEZ
          </h2>
          <p>
            6.1 Quý Đối Tác cấp cho ALPHA SPACEZ quyền trên cơ sở không độc quyền để sử dụng các tài
            liệu hoặc thông tin mà Quý Đối Tác cung cấp trên Ứng Dụng và/hoặc cung cấp cho ALPHA
            SPACEZ, bao gồm nhưng không giới hạn các câu hỏi, đánh giá, nhận xét, đề xuất, các yêu
            cầu công việc, bất cứ thông tin, tài liệu, nội dung nào do Quý Đối Tác cung cấp cho
            ALPHA SPACEZ (gọi chung là “Thông Tin Người Sử Dụng Cung Cấp”). Khi Quý Đối Tác đăng
            nhận xét hoặc đánh giá lên Website, Quý Đối Tác cung cấp cho ALPHA SPACEZ quyền được sử
            dụng tên mà Quý Đối Tác sử dụng hoặc Tên Người Dùng của Quý Đối Tác đã đưa ra đánh giá,
            nhận xét hoặc nội dung khác. Quý Đối Tác không được sử dụng thư điện tử giả, giả mạo
            danh tính của người khác hoặc sử dụng địa chỉ thư điện tử gây hiểu lầm cho ALPHA SPACEZ
            hoặc các bên thứ ba về Thông Tin Người Sử Dụng Cung Cấp. ALPHA SPACEZ có thể, nhưng
            không có nghĩa vụ phải công bố, xóa bỏ hoặc chỉnh sửa Thông Tin Người Sử Dụng Cung Cấp.
          </p>
        </section>

        {/* Section 7 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">7. CHẤM DỨT</h2>
          <h3 className="font-bold text-gray-800 mt-4 mb-2">7.1 Chấm dứt bởi ALPHA SPACEZ</h3>
          <p className="mb-2">
            ALPHA SPACEZ có quyền đình chỉ hoặc chấm dứt quyền truy cập của Quý Đối Tác vào Ứng Dụng
            hoặc sử dụng bất kỳ tính năng nào của Ứng Dụng hoặc xóa Tài Khoản Người Dùng của Quý Đối
            Tác trong các trường hợp sau:
          </p>
          <div className="pl-4 md:pl-8 space-y-2 mb-4 text-gray-700">
            <p>
              (a) Quý Đối Tác vi phạm các quy định tại Điều Khoản Sử Dụng này, các điều khoản hoặc
              chính sách khác được đăng tải công khai trên Ứng Dụng;
            </p>
            <p>
              (b) ALPHA SPACEZ thực hiện theo yêu cầu của pháp luật, hoặc do cơ quan có thẩm quyền
              yêu cầu hoặc theo lệnh của tòa án;
            </p>
            <p>
              (c) ALPHA SPACEZ có cơ sở để tin rằng hành vi của Quý Đối Tác đã gây ra tổn hại hoặc
              tổn thất cho người dùng khác hoặc bên thứ ba – ví dụ: tấn công, lừa đảo, quấy rối, gửi
              thư rác, lừa dối người khác hoặc sao chép nội dung không thuộc về Quý Đối Tác;
            </p>
            <p>
              (d) trong trường hợp có cơ sở để chứng minh thông tin Quý Đối Tác cung cấp cho ALPHA
              SPACEZ là không chính xác, sai lệch, không đầy đủ hoặc vi phạm pháp luật hay thuần
              phong mỹ tục Việt Nam;
            </p>
            <p>
              (e) Quý Đối Tác có những hành vi ảnh hưởng đến hoạt động kinh doanh của ALPHA SPACEZ
              trên Ứng Dụng;
            </p>
            <p>
              (f) Quý Đối Tác phá sản, bị kết án hoặc đang trong thời gian thụ án, trong trường hợp
              Quý Đối Tác tiếp tục hoạt động có thể gây cho Ứng Dụng trách nhiệm pháp lý, có những
              hoạt động lừa đảo, giả mạo, gây rối loạn thị trường, gây mất đoàn kết đối với các
              người dùng khác của Ứng Dụng, hoạt động vi phạm pháp luật hiện hành của Việt Nam.
            </p>
          </div>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">7.2 Chấm Dứt bởi Quý Đối Tác</h3>
          <p>
            Quý Đối Tác có toàn quyền ngừng truy cập Ứng Dụng hoặc sử dụng các tính năng trên Ứng
            Dụng theo ý muốn của mình. Quý Đối Tác có thể ngừng sử dụng Ứng Dụng bằng cách hủy kích
            hoạt Tài Khoản Người Dùng, ngừng truy cập vào Ứng Dụng bất kỳ lúc nào. Để làm rõ, việc
            Quý Đối Tác chấm dứt sử dụng Ứng Dụng không đồng nghĩa với việc chấm dứt các nghĩa vụ
            của Quý Đối Tác với ALPHA SPACEZ phát sinh trước thời điểm chấm dứt, Quý Đối Tác vẫn có
            nghĩa vụ hoàn thành các nghĩa vụ này. Việc hủy các Đơn Đặt Hàng sẽ được thực hiện theo
            quy định tại Phụ Đính 2.
          </p>
        </section>

        {/* Section 8 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">8. THÔNG BÁO</h2>
          <h3 className="font-bold text-gray-800 mt-4 mb-2">8.1 Thông Báo Từ ALPHA SPACEZ</h3>
          <p className="mb-2">
            Tất cả các thông báo hoặc thông tin liên lạc khác được xem là đã gửi cho Quý Đối Tác
            nếu:
          </p>
          <div className="pl-4 md:pl-8 space-y-2 mb-4 text-gray-700">
            <p>
              (a) được gửi cho Quý Đối Tác qua bất kỳ phương thức in ấn hoặc điện tử mà ALPHA SPACEZ
              lựa chọn, sẽ được coi là đã được thông báo đến Quý Đối Tác vào ngày thông báo được
              công bố hoặc phát sóng; hoặc
            </p>
            <p>
              (b) được gửi qua đường bưu điện hoặc gửi đến địa chỉ của Quý Đối Tác, sẽ được xem là
              Quý Đối Tác đã nhận được vào ngày ký nhận thông báo.
            </p>
          </div>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">8.2 Thông Báo Từ Quý Đối Tác</h3>
          <p>
            Quý Đối Tác chỉ có thể thông báo cho ALPHA SPACEZ bằng văn bản được gửi đến địa chỉ 210
            Bùi Văn Ba, Phường Tân Thuận, Thành phố Hồ Chí Minh, Việt Nam hoặc gửi qua địa chỉ thư
            điện tử:{" "}
            <a href="mailto:support@zzp.vn" className="text-blue-600 hover:underline">
              support@zzp.vn
            </a>{" "}
            hoặc liên lạc với ALPHA SPACEZ thông qua bộ phận chăm sóc khách hàng theo hotline:{" "}
            <a href="tel:0779827236" className="text-blue-600 hover:underline">
              0779827236
            </a>
            , và ALPHA SPACEZ chỉ được xem là đã nhận được thông báo sau khi ký nhận thông báo đó
            (nếu thông báo được gửi bằng văn bản). Mặc dù ALPHA SPACEZ cố gắng phản hồi nhanh chóng
            các thông báo từ Quý Đối Tác, ALPHA SPACEZ không thể đảm bảo rằng ALPHA SPACEZ sẽ luôn
            phản hồi nhanh nhất.
          </p>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">8.3 Các Phương Thức Khác</h3>
          <p>
            Không ảnh hưởng đến các Mục 8.1 và 8.2 trên đây, ALPHA SPACEZ có quyền thay đổi các
            phương thức thông báo thông tin vào từng thời điểm (bao gồm nhưng không giới hạn đối với
            thư điện tử, tin nhắn văn bản SMS hoặc các hình thức liên lạc điện tử khác) vào thời
            gian hoặc thời điểm mà thông báo được gửi.
          </p>
        </section>

        {/* Section 9 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">9. ĐIỀU KHOẢN CHUNG</h2>
          <div className="space-y-4">
            <p>
              9.1 Quyền Và Yêu Cầu Bồi Thường: Trừ khi được quy định khác đi trong Điều Khoản Sử
              Dụng này, quyền và yêu cầu bồi thường của ALPHA SPACEZ theo Điều Khoản Sử Dụng này sẽ
              được tích lũy và không ảnh hưởng đến và thêm vào bất kỳ quyền hoặc yêu cầu bồi thường
              nào khác của ALPHA SPACEZ theo quy định của pháp luật. Việc ALPHA SPACEZ không thực
              hiện bất kỳ quyền hoặc yêu cầu bồi thường nào theo Điều Khoản Sử Dụng này, hoặc theo
              pháp luật (trừ trường hợp được quy định rõ trong Điều Khoản Sử Dụng này hoặc theo pháp
              luật nếu có) sẽ không được xem là cản trở hoặc ngăn cản việc ALPHA SPACEZ thực hiện
              bất kỳ quyền hoặc biện pháp khắc phục nào khác theo quy định của pháp luật.
            </p>
            <p>
              9.2 Không Từ bỏ: Việc ALPHA SPACEZ không thực thi Điều Khoản Sử Dụng này sẽ không được
              xem là ALPHA SPACEZ đã từ bỏ quyền được thực hiện các điều khoản đó và việc không thực
              thi này sẽ không ảnh hưởng đến quyền được thực thi Điều Khoản Sử Dụng trong tương lai.
              ALPHA SPACEZ vẫn có quyền thực hiện các quyền và yêu cầu bồi thường của mình trong bất
              kỳ trường hợp khi Quý Đối Tác vi phạm Điều Khoản Sử Dụng này.
            </p>
            <p>
              9.3 Hiệu Lực Từng Phần: Nếu bất kỳ điều khoản nào của Điều Khoản Sử Dụng được coi là
              bất hợp pháp, không hợp lệ hoặc không thể thực thi ở bất kỳ khía cạnh nào, thì tính
              pháp lý, tính hợp lệ và tính thực thi của những điều khoản khác trong Điều Khoản Sử
              Dụng này và phần còn lại của điều khoản bị ảnh hưởng trong Điều Khoản Sử Dụng này vẫn
              tiếp tục có hiệu lực; và có hiệu lực như thể những nội dung bất hợp pháp, không hợp lệ
              hoặc không thể thực thi đã bị xóa bỏ khỏi Điều Khoản Sử Dụng này.
            </p>
            <p>
              9.4 Luật Điều Chỉnh Và Giải Quyết Tranh Chấp: Việc sử dụng Ứng Dụng và Điều Khoản Sử
              Dụng này sẽ được điều chỉnh và giải thích theo pháp luật Việt Nam. Bất kỳ tranh chấp
              phát sinh hoặc liên quan đến Điều Khoản Sử Dụng này, bao gồm sự tồn tại, hiệu lực,
              cách giải thích, cách thực hiện, vi phạm hoặc chấm dứt Điều Khoản Sử Dụng này; hoặc
              bất kỳ tranh chấp nào liên quan đến các nghĩa vụ ngoài hợp đồng phát sinh hoặc liên
              quan đến Điều Khoản Sử Dụng này thì vụ việc tranh chấp đó sẽ được đưa ra xét xử và
              giải quyết cuối cùng bởi Tòa án có thẩm quyền tại Thành phố Hồ Chí Minh.
            </p>
            <p>
              9.5 Sửa Lỗi: Mọi lỗi về đánh máy, văn thư, hoặc các lỗi hoặc thiếu sót khác trong bất
              kỳ chấp thuận, hóa đơn hoặc tài liệu nào khác từ phía ALPHA SPACEZ sẽ có thể được
              ALPHA SPACEZ đính chính lại mà không làm phát sinh bất kỳ trách nhiệm nào đối với
              ALPHA SPACEZ.
            </p>
            <p>
              9.6 Sự Ràng Buộc và Đồng Bộ: Quý Đối Tác thừa nhận và đồng ý rằng bất kỳ tài liệu lưu
              trữ nào (bao gồm tài liệu về bất kỳ cuộc trò chuyện qua điện thoại liên quan đến Ứng
              Dụng hoặc dịch vụ, công việc hợp tác giữa ALPHA SPACEZ và Quý Đối Tác, nếu có) do
              ALPHA SPACEZ hoặc các nhà cung cấp Dịch Vụ của ALPHA SPACEZ lưu giữ sẽ là cơ sở có giá
              trị ràng buộc và là bằng chứng sau cùng về bất kỳ thông tin và/hoặc dữ liệu nào được
              chuyển giao giữa ALPHA SPACEZ và Quý Đối Tác. Quý Đối Tác theo đây đồng ý rằng tất cả
              các tài liệu như vậy đều có thể được xem là bằng chứng và Quý Đối Tác sẽ không phản
              đối hoặc tranh chấp về khả năng chấp nhận, độ tin cậy, độ chính xác hoặc tính xác thực
              của các tài liệu này chỉ vì lý do các tài liệu này ở dạng điện tử hoặc trích xuất từ
              hệ thống máy tính và Quý Đối Tác từ bỏ bất kỳ quyền của mình, nếu có, để phản đối theo
              đó.
            </p>
            <p>
              9.7 Giao Thầu Phụ và Chỉ Định: ALPHA SPACEZ có quyền chỉ định hoặc giao nhà thầu phụ
              thực hiện bất kỳ phần nội dung công việc nào của ALPHA SPACEZ liên quan đến Ứng Dụng
              và ALPHA SPACEZ có quyền sử dụng bất kỳ nhà cung cấp dịch vụ, nhà thầu phụ và/hoặc đại
              lý ủy quyền theo các điều khoản và điều kiện mà ALPHA SPACEZ cho là phù hợp.
            </p>
            <p>
              9.8 Chuyển Nhượng: Quý Đối Tác không được chuyển nhượng các quyền và nghĩa vụ của mình
              theo Điều Khoản Sử Dụng này mà không được sự đồng ý trước bằng văn bản của ALPHA
              SPACEZ. ALPHA SPACEZ có quyền chuyển nhượng các quyền và nghĩa vụ của mình theo Điều
              Khoản Sử Dụng này cho bất kỳ bên thứ ba nào.
            </p>
            <p>
              9.9 Trường Hợp Bất Khả Kháng: ALPHA SPACEZ sẽ không chịu trách nhiệm về việc không
              thực hiện, lỗi, gián đoạn hoặc chậm trễ trong việc thực hiện các nghĩa vụ của mình
              theo Điều Khoản Sử Dụng này (hoặc bất kỳ phần nào trong đó) hoặc bất kỳ sự không chính
              xác, không đáng tin cậy hoặc không phù hợp nào trên Ứng Dụng nếu điều này là do, toàn
              bộ hoặc một phần, trực tiếp hoặc gián tiếp phát sinh từ một sự kiện hoặc lỗi nằm ngoài
              tầm kiểm soát hợp lý của ALPHA SPACEZ.
            </p>
          </div>
        </section>

        <div className="border-t my-8 border-gray-300"></div>

        {/* PHỤ ĐÍNH 1 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">
            PHỤ ĐÍNH 1 – ĐỊNH NGHĨA VÀ GIẢI THÍCH
          </h2>
          <h3 className="font-bold text-gray-800 mt-4 mb-2">1. Định Nghĩa:</h3>
          <div className="pl-4 md:pl-8 space-y-2 mb-4 text-gray-700">
            <p>
              1.1. “Quý Đối Tác” có nghĩa là các tổ chức, cá nhân sử dụng hoặc có nhu cầu sử dụng
              Ứng Dụng.
            </p>
            <p>
              1.2. “Quyền Sở Hữu Trí Tuệ” có nghĩa là tất cả quyền tác giả, quyền liên quan đến
              quyền tác giả, quyền sở hữu đối với sáng chế, nhãn hiệu, tên miền, thiết kế, quyền cơ
              sở dữ liệu, tên thương mại, quyền bảo vệ bí mật thương mại và thông tin bảo mật, quyền
              bảo vệ lợi thế thương mại và danh tiếng, và tất cả các quyền sở hữu trí tuệ tương tự
              khác và tất cả các đơn đăng ký các quyền này, cho dù ở hiện tại hay được tạo ra trong
              tương lai, ở bất kỳ khu vực nào trên thế giới, cho dù đã đăng ký hay chưa đăng ký, và
              tất cả các quyền lợi, đặc quyền, quyền khởi kiện, bồi thường thiệt hại, và yêu cầu áp
              dụng biện pháp khẩn cấp tạm thời đối với bất kỳ hành vi vi phạm đến các quyền này, dù
              hành vi vi phạm này được thực hiện ở quá khứ, hiện tại hoặc trong tương lai.
            </p>
            <p>
              1.3. “ALPHA SPACEZ”, “chúng tôi” đề cập đến Công ty Cổ phần ALPHA SPACEZ (tên tiếng
              Anh: ALPHA SPACEZ JOINT STOCK), một công ty được thành lập và hoạt động theo pháp luật
              Việt Nam theo Giấy chứng nhận đăng ký doanh nghiệp số 0319219773, do Sở Tài chính
              Thành phố Hồ Chí Minh cấp đăng ký lần đầu ngày 16 tháng 10 năm 2025, có trụ sở tại 210
              Bùi Văn Ba, Phường Tân Thuận, Thành phố Hồ Chí Minh, Việt Nam.
            </p>
            <p>
              1.4. “Tổn Thất” có nghĩa là tất cả tiền phạt, tổn thất, chi phí dàn xếp, chi phí (bao
              gồm chi phí pháp lý và phí luật sư), các khoản phí, hành động, thủ tục, khiếu nại, yêu
              cầu và các yêu cầu bồi thường khác, cho dù có thể lường trước được hay không.
            </p>
            <p>
              1.5. “Tài Liệu” có nghĩa là bao gồm thông tin, hình ảnh, đường dẫn liên kết, âm thanh,
              đồ họa, đoạn phim, phần mềm, ứng dụng và các tài liệu khác được hiển thị hoặc cung cấp
              trên Ứng Dụng và các chức năng hoặc dịch vụ được cung cấp trên Ứng Dụng.
            </p>
            <p>
              1.6. “Đơn Đặt Hàng” có nghĩa là yêu cầu sử dụng dịch vụ của ALPHA SPACEZ gửi đến Quý
              Đối Tác được thể hiện thông tin trên Ứng Dụng phù hợp với quy định tại Phụ Đính 2 –
              Điều Khoản Và Điều Kiện Cung Cấp Dịch Vụ.
            </p>
            <p>
              1.7. “Mật Khẩu” có nghĩa là mật khẩu hợp lệ mà Quý Đối Tác có Tài Khoản Người Dùng với
              ALPHA SPACEZ có quyền sử dụng cùng với Tên Người Dùng để truy cập Ứng Dụng.
            </p>
            <p>
              1.8. “Dữ Liệu Cá Nhân” có nghĩa là các dữ liệu cá nhân được quy định tại Chính Sách
              Bảo Vệ Dữ Liệu Cá Nhân.
            </p>
            <p>
              1.9. “Ứng Dụng” có nghĩa là chương trình máy tính mang tên ZZP thuộc sở hữu của ALPHA
              SPACEZ.
            </p>
            <p>
              1.10. “Dịch Vụ” có nghĩa là các dịch vụ, công việc, sản phẩm do Quý Đối Tác thực hiện,
              cung ứng cho ALPHA SPACEZ và được ALPHA SPACEZ quản lý thông qua Ứng Dụng.
            </p>
            <p>
              1.11. “Tài Liệu Bị Cấm” có nghĩa là bất kỳ thông tin, đồ họa, ảnh, dữ liệu và/hoặc bất
              kỳ tài liệu khác có nội dung: (a) chứa vi rút máy tính hoặc mã xâm nhập, mã phá hoại
              hoặc chương trình gây hại khác; (b) vi phạm bất kỳ Quyền Sở Hữu Trí Tuệ hoặc bất kỳ
              quyền sở hữu nào khác của bên thứ ba; (c) phỉ báng, bôi nhọ hoặc đe dọa; (d) tục tĩu,
              khiêu dâm, khiếm nhã, giả mạo, gian lận, ăn cắp, có hại, hoặc có nội dung bất hợp pháp
              theo quy định của pháp luật hiện hành; và/hoặc (e) được xem là xúc phạm và/hoặc bị
              phản đối theo ý kiến riêng của chúng tôi.
            </p>
            <p>
              1.12. “Thông Tin Người Sử Dụng Cung Cấp” được định nghĩa trong Mục 6.1 của Điều Khoản
              Sử Dụng.
            </p>
            <p>
              1.13. “Điều Khoản và Điều Kiện Cung Cấp Dịch Vụ” có nghĩa là các điều khoản và điều
              kiện điều chỉnh việc Quý Đối Tác cung cấp Dịch Vụ cho ALPHA SPACEZ cũng như điều chỉnh
              việc Quý Đối Tác truy cập Ứng Dụng và sử dụng các tính năng trên Ứng Dụng, được quy
              định chi tiết tại Phụ Đính 2.
            </p>
            <p>
              1.14. “Điều Khoản Sử Dụng” có nghĩa là các điều khoản và điều kiện chung điều chỉnh
              việc Quý Đối Tác sử dụng Ứng Dụng, bao gồm cả Phụ Đính 1 và Phụ Đính 2.
            </p>
            <p>
              1.15. “Nhãn Hiệu” có nghĩa là bất kỳ dấu hiệu được sử dụng để phân biệt hàng hóa hoặc
              dịch vụ khác nhau, bao gồm nhãn hiệu, nhãn hiệu dịch vụ, tên thương mại và logo được
              sử dụng và hiển thị trên Ứng Dụng.
            </p>
            <p>
              1.16. “Tên Người Dùng” là tên hoặc mã nhận dạng đăng nhập duy nhất để xác định Quý Đối
              Tác có tài khoản trên Ứng Dụng.
            </p>
            <p>
              1.17. “Ngày Làm Việc” có nghĩa là ngày mà các ngân hàng thường mở cửa hoạt động tại
              Việt Nam (không bao gồm các ngày lễ, ngày Thứ bảy và Chủ nhật).
            </p>
            <p>
              1.18. “Người Dùng” có nghĩa là các cá nhân, tổ chức đã đăng ký Tài Khoản Người Dùng
              trên Ứng Dụng.
            </p>
            <p>
              1.19. “Tài Khoản Người Dùng” có nghĩa là tài khoản điện tử trên Ứng Dụng do Quý Đối
              Tác đăng ký khởi tạo và được ALPHA SPACEZ chấp nhận kích hoạt khởi tạo để Quý Đối Tác
              có thể truy cập Ứng Dụng và/hoặc sử dụng các tính năng trên Ứng Dụng.
            </p>
          </div>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">2. Diễn Giải:</h3>
          <p>
            Mọi tham chiếu trong Điều Khoản Sử Dụng này đến bất kỳ điều khoản nào sẽ được hiểu là
            bao gồm tham chiếu đến điều khoản đó đã được sửa đổi, ban hành lại hoặc bổ sung vào thời
            điểm có liên quan. Trong Điều Khoản Sử Dụng này, bất cứ khi nào từ “bao gồm” hoặc từ
            đồng nghĩa được sử dụng, các từ này sẽ được xem là có từ “không giới hạn” theo sau. Trừ
            khi được quy định rõ ràng khác đi, tất cả các tham chiếu đến ngày có nghĩa là ngày dương
            lịch và các từ “tháng” hoặc “hàng tháng” cũng như tất cả các tham chiếu đến tháng có
            nghĩa là tháng dương lịch. Các tiêu đề của mỗi điều khoản được thêm vào nhằm mục đích
            thuận tiện theo dõi và sẽ không ảnh hưởng đến việc giải thích nội dung của các Điều
            Khoản Sử Dụng. Trong trường hợp có xung đột hoặc mâu thuẫn giữa bất kỳ điều khoản nào
            trong Điều Khoản Sử Dụng này, cho dù các điều khoản đó có trong cùng một tài liệu hay
            các tài liệu khác nhau, xung đột hoặc mâu thuẫn đó sẽ được giải quyết theo hướng phù hợp
            với ngữ cảnh nhất.
          </p>
        </section>

        <div className="border-t my-8 border-gray-300"></div>

        {/* PHỤ ĐÍNH 2 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4 uppercase">
            PHỤ ĐÍNH 2 – ĐIỀU KHOẢN VÀ ĐIỀU KIỆN CUNG CẤP DỊCH VỤ
          </h2>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">1. Sự Tuân Thủ Của Quý Đối Tác</h3>
          <p>
            Quý Đối Tác đồng ý tuân thủ với tất cả hướng dẫn, thông báo, quy tắc hoạt động, chính
            sách và chỉ dẫn liên quan đến việc sử dụng các tính năng được cung cấp trên Ứng Dụng,
            cũng như bất kỳ sửa đổi, điều chỉnh nào đối với những quy định nói trên do ALPHA SPACEZ
            ban hành vào từng thời điểm. ALPHA SPACEZ có quyền sửa đổi các hướng dẫn, thông báo, quy
            tắc hoạt động, chính sách và chỉ dẫn vào bất kỳ thời điểm nào bằng cách thông báo trước
            cho Quý Đối Tác và Quý Đối Tác được xem là đã biết và chịu sự ràng buộc với những thay
            đổi, điều chỉnh sau khi những thông báo, điều chỉnh này được công bố trên Ứng Dụng phù
            hợp với chính sách của ALPHA SPACEZ và quy định pháp luật áp dụng.
          </p>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">2. Các loại phí</h3>
          <p>
            Xem chi tiết tại <strong>“Chính sách phí và thanh toán”</strong>
          </p>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">
            3. Yêu Cầu Sử Dụng Dịch Vụ Và Xác Nhận
          </h3>
          <p className="mb-2">
            3.1 Đơn Đặt Hàng sẽ được ALPHA SPACEZ gửi đến Quý Đối Tác dưới dạng các bảng tin về
            chiến dịch (thể hiện thông tin chiến dịch) ở mục “Khám phá” trên Ứng Dụng. Để đăng ký
            tham gia chiến dịch theo Đơn Đặt Hàng của ALPHA SPACEZ, Quý Đối Tác cần cung cấp nội
            dung giới thiệu về bản thân, công việc thông qua Ứng Dụng. Quý Đối Tác phải chịu trách
            nhiệm đảm bảo tính chính xác của thông tin mà Quý Đối Tác cung cấp. ALPHA SPACEZ chỉ
            được xem là đồng ý sử dụng Dịch Vụ của Quý Đối Tác và giao dịch giữa ALPHA SPACEZ và Quý
            Đối Tác được xem là xác lập khi đăng ký tham gia chiến dịch của Quý Đối Tác được ALPHA
            SPACEZ chấp thuận/ phê duyệt.
          </p>
          <p className="mb-2">
            Để đảm bảo tính công bằng và bảo vệ quyền lợi của tất cả Quý Đối Tác, ALPHA SPACEZ có
            quyền từ chối các yêu cầu đăng ký tham gia chiến dịch (sau đây gọi tắt là “Yêu Cầu Tham
            Gia”) thuộc (nhưng không giới hạn) các trường hợp sau:
          </p>
          <div className="pl-4 md:pl-8 space-y-2 mb-4 text-gray-700">
            <p>
              (a) Các Yêu Cầu Tham Gia nhằm phục vụ cho mục đích vi phạm pháp luật, trái đạo đức,
              thuần phong mỹ tục Việt Nam.
            </p>
            <p>
              (b) Nếu Quý Đối Tác không tuân thủ bất kỳ quy định, chính sách nào của ALPHA SPACEZ,
              ALPHA SPACEZ có quyền từ chối Yêu Cầu Tham Gia của Quý Đối Tác cũng như đình chỉ hoặc
              chấm dứt Tài Khoản Người Dùng của Quý Đối Tác vĩnh viễn mà không cần thông báo trước.
            </p>
          </div>
          <p>
            3.2 Sau khi Yêu Cầu Tham Gia đã được ALPHA SPACEZ chấp thuận, Quý Đối Tác sẽ không thể
            hủy ngang, vô điều kiện các Yêu Cầu Tham Gia đó. Trong một số trường hợp nhất định như
            đã nêu trong Điều Khoản Sử Dụng (nếu có), Quý Đối Tác có quyền yêu cầu hủy bỏ đối với
            Yêu Cầu Tham Gia đã được ALPHA SPACEZ chấp nhận, tuy nhiên, không ảnh hưởng đến quy định
            trên đây, ALPHA SPACEZ sẽ là bên cuối cùng có quyền quyết định về việc có hoặc không
            thực hiện yêu cầu hủy bỏ này của Quý Đối Tác.
          </p>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">4. Hình thức thanh toán</h3>
          <p>
            Xem chi tiết tại <strong>“Chính sách phí và thanh toán”</strong>
          </p>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">5. Thực Hiện Giao Dịch Tại Ứng Dụng</h3>
          <p className="mb-2">
            Quy trình giao dịch trên Ứng Dụng của Quý Đối Tác về cơ bản sẽ được thực hiện theo trình
            tự sau:
          </p>
          <div className="pl-4 md:pl-8 space-y-2 mb-4 text-gray-700">
            <p>
              (a) Bước 1: Quý Đối Tác tiến hành tạo tài khoản trên Ứng Dụng đối với nền tảng “Nhà
              sáng tạo”
            </p>
            <p>
              (b) Bước 2: Quý Đối Tác theo dõi thông tin các chiến dịch của Nhãn hàng tại mục “Khám
              phá”, để xem thông tin chi tiết của chiến dịch Quý Đối Tác nhấn “Chi tiết” ở chiến
              dịch tương ứng. Nếu chiến dịch phù hợp và Quý Đối Tác muốn tham gia thì nhấp “Đăng ký”
              → viết “Lời giới thiệu” để mô tả sơ lược về bản thân → nhấp “Gửi”. Thông tin đăng ký
              của Quý Đối Tác sẽ được xem xét và chấp thuận nếu Quý Đối Tác phù hợp với chiến dịch.
            </p>
            <p>
              (c) Bước 3: Quý Đối Tác theo dõi thông tin đăng ký và thực hiện chiến dịch tại mục
              “Quản lý”, với các mục tương ứng “Đã đăng ký”, “Đã được duyệt”, “Đang làm”, “Hoàn
              thành”, “Từ chối”.
            </p>
            <p>
              (d) Bước 4: Đối với các chiến dịch mà Quý Đối Tác được duyệt tham gia, Quý Đối Tác
              đăng tải các bản nháp công việc thực hiện (hình ảnh, đoạn phim quảng cáo,...) theo yêu
              cầu của chiến dịch theo thời gian “Đăng bản nháp” được thể hiện ở chi tiết chiến dịch.
            </p>
            <p>
              (e) Bước 5: Quý Đối Tác đảm bảo liên tục theo dõi chiến dịch, trao đổi, nhận phản hồi,
              điều chỉnh theo yêu cầu (nếu có) để hoàn thiện Dịch Vụ.
            </p>
            <p>
              (f) Bước 6: Quý Đối Tác đảm bảo đăng bài đúng hạn (Ngày kết thúc chiến dịch), sau khi
              đăng bài lên các trang mạng xã hội như yêu cầu, Quý Đối Tác sao chép đường dẫn của bài
              đăng và dán vào mục “Bài đăng” trên Ứng Dụng nhằm phục vụ cho mục đích nghiệm thu.
            </p>
            <p>
              (g) Bước 7: Sau khi nghiệm thu Dịch Vụ do Quý Đối Tác đã thực hiện, ALPHA SPACEZ sẽ
              ghi nhận Phí Dịch Vụ vào “Tổng thu nhập” của Quý Đối Tác trong Mục “Số dư” và việc
              thanh toán Phí Dịch Vụ cho Quý Đối Tác sẽ được thực hiện theo “
              <strong>Chính sách phí và thanh toán</strong>”.
            </p>
          </div>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">
            6. Chính Sách Chất Lượng Ứng Dụng - Dịch Vụ
          </h3>
          <div className="pl-4 md:pl-8 space-y-2 mb-4 text-gray-700">
            <p>
              6.1 ALPHA SPACEZ hướng đến việc cung cấp Ứng Dụng có chất lượng tốt nhất cho Quý Đối
              Tác và từ chối cung cấp các tính năng, công việc vi phạm quy định của pháp luật Việt
              Nam.
            </p>
            <p>
              6.2 Trong trường hợp Quý Đối Tác phát hiện bất kỳ tính năng, hoặc chiến dịch nào hiển
              thị trên Ứng Dụng có dấu hiệu vi phạm hoặc không hài lòng về chất lượng Dịch Vụ, vui
              lòng thông báo ngay cho ALPHA SPACEZ theo thông tin bên dưới để được xác thực thông
              tin và hỗ trợ.
            </p>
            <div className="bg-gray-100 p-4 rounded mt-2">
              <p className="font-semibold">Thông tin liên hệ phản ánh chất lượng Ứng Dụng:</p>
              <p>CÔNG TY CỔ PHẦN ALPHA SPACEZ</p>
              <p>Địa chỉ: 210 Bùi Văn Ba, Phường Tân Thuận, Thành phố Hồ Chí Minh.</p>
              <p>
                Số điện thoại (phản ánh chất lượng):{" "}
                <a href="tel:0779827236" className="text-blue-600 hover:underline">
                  0779827236
                </a>
              </p>
              <p>
                Email (phản ánh chất lượng):{" "}
                <a href="mailto:support@zzp.vn" className="text-blue-600 hover:underline">
                  support@zzp.vn
                </a>
              </p>
            </div>
            <p>
              6.3 Trường hợp Dịch Vụ không đảm bảo chất lượng do lỗi của Quý Đối Tác thì Quý Đối Tác
              phải bồi thường cho ALPHA SPACEZ, trong mọi trường hợp ALPHA SPACEZ được quyền giữ lại
              Phí Dịch Vụ của Quý Đối Tác cho đến khi khiếu nại, tranh chấp giữa hai bên được giải
              quyết.
            </p>
          </div>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">7. Hủy Bỏ Dịch Vụ Đã Xác Nhận</h3>
          <div className="pl-4 md:pl-8 space-y-2 mb-4 text-gray-700">
            <p>
              7.1 Nếu Yêu Cầu Tham Gia đã được ALPHA SPACEZ xác nhận thì Quý Đối Tác không được hủy
              vì bất cứ lý do nào.
            </p>
            <p>
              7.2 Lưu ý rằng đối với việc Quý Đối Tác thay đổi hoặc hủy bỏ Yêu Cầu Tham Gia đã được
              ALPHA SPACEZ xác nhận, ALPHA SPACEZ có quyền giữ lại bất cứ khoản Phí Dịch Vụ nào chưa
              được Quý Đối Tác thực hiện công việc và/hoặc bồi thường thiệt hại, cụ thể sẽ theo thỏa
              thuận giữa ALPHA SPACEZ và Quý Đối Tác.
            </p>
          </div>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">
            8. Hệ Quả Do Lỗi Nhập Sai Thông Tin Trên Ứng Dụng
          </h3>
          <div className="pl-4 md:pl-8 space-y-2 mb-4 text-gray-700">
            <p>
              8.1 Quý Đối Tác có trách nhiệm cung cấp đầy đủ và chính xác thông tin khi tham gia
              giao dịch trên Ứng Dụng. Trong trường hợp Quý Đối Tác nhập sai thông tin khi đăng nhập
              và/hoặc khi thanh toán hay bất kỳ thông tin nào khác dẫn tới việc giao dịch không thể
              thực hiện và/hoặc gián đoạn giao dịch, ALPHA SPACEZ có quyền từ chối thực hiện giao
              dịch mà không phải chịu trách nhiệm đối với việc hủy Dịch Vụ.
            </p>
            <p>
              8.2 Trong trường hợp Quý Đối Tác liên hệ ALPHA SPACEZ hoặc ALPHA SPACEZ liên hệ Quý
              Đối Tác để xác nhận Yêu Cầu Tham Gia vì bất cứ lý do gì, nếu Quý Đối Tác không thể trả
              lời và/hoặc xác minh chính xác được những thông tin cần thiết theo yêu cầu của ALPHA
              SPACEZ thì ALPHA SPACEZ có quyền hủy Yêu Cầu Tham Gia trong trường hợp này.
            </p>
          </div>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">9. Quy Định Về Bảo Mật</h3>
          <div className="pl-4 md:pl-8 space-y-2 mb-4 text-gray-700">
            <p>
              9.1 Ứng Dụng có các biện pháp và công cụ về bảo mật để bảo vệ Dữ Liệu Cá Nhân và việc
              thanh toán cho Quý Đối Tác một cách toàn diện nhất. Thông tin của Quý Đối Tác trong
              quá trình thanh toán sẽ được mã hóa để đảm bảo bảo mật tối đa. Mọi thông tin giao dịch
              sẽ được bảo mật nhưng trong trường hợp cơ quan pháp luật có yêu cầu bằng văn bản,
              ALPHA SPACEZ sẽ phải cung cấp những thông tin này cho các cơ quan chức năng theo đúng
              quy định pháp luật.
            </p>
            <p>
              9.2 Quý Đối Tác không được sử dụng bất kỳ chương trình, công cụ hay hình thức nào khác
              để can thiệp vào hệ thống hay làm thay đổi cấu trúc dữ liệu. ALPHA SPACEZ nghiêm cấm
              việc phát tán, truyền bá hay cổ vũ cho bất kỳ hoạt động nào nhằm can thiệp, phá hoại
              hay xâm nhập vào dữ liệu của hệ thống. Cá nhân hay tổ chức vi phạm sẽ bị tước bỏ mọi
              quyền lợi cũng như sẽ bị truy tố trước pháp luật nếu cần thiết.
            </p>
            <p>
              9.3 Quý Đối Tác phải bảo mật tất cả các thông tin liên quan đến hoạt động kinh doanh
              của ALPHA SPACEZ hoặc bên thứ ba liên quan (như nhãn hàng, nhà cung cấp, đối tác, nhà
              đầu tư… của ALPHA SPACEZ), bao gồm nhưng không giới hạn ở kế hoạch bán sản phẩm, kế
              hoạch truyền thông, nghiên cứu thị trường, chiến dịch khuyến mại, số liệu kinh doanh,
              các hoạt động tiếp thị, số liệu kế toán thống kê, báo cáo, thông tin về các chiến dịch
              của nhãn hàng và các hoạt động khác liên quan đến ALPHA SPACEZ mà Quý Đối Tác biết
              được khi tham gia giao dịch với ALPHA SPACEZ (“<strong>Thông Tin Mật</strong>”). Quý
              Đối Tác không được thực hiện các hành vi, hành động sau đây, dù bằng bất cứ hình thức
              nào, nếu không có đồng ý trước bằng văn bản của ALPHA SPACEZ:
            </p>
            <div className="pl-4 md:pl-8">
              <p>
                (a) Khai thác, sử dụng trái phép một cách gián tiếp hoặc trực tiếp bất cứ phần nào
                của Thông Tin Mật.
              </p>
              <p>
                (b) Gián tiếp hoặc trực tiếp tiết lộ cho bất cứ Bên thứ ba nào khác về bất cứ phần
                nào của Thông Tin Mật.
              </p>
              <p>
                (c) Chia sẻ các thông tin về hợp đồng, giao dịch giữa Quý Đối Tác và ALPHA SPACEZ,
                thông tin mà Quý Đối Tác có được trong quá trình giao dịch với ALPHA SPACEZ khi chưa
                được sự đồng ý bằng văn bản của ALPHA SPACEZ.
              </p>
            </div>
            <p>
              9.4 Quý Đối Tác công nhận rằng bất kỳ vi phạm nào liên quan đến nghĩa vụ bảo mật thông
              tin sẽ gây thiệt hại không thể khắc phục cho ALPHA SPACEZ, do đó trong trường hợp Quý
              Đối Tác vi phạm cam kết bảo mật này ALPHA SPACEZ có quyền ngay lập tức chấm dứt các
              hợp đồng, giao dịch, thỏa thuận với Quý Đối Tác, chấm dứt Tài Khoản Người Dùng của Quý
              Đối Tác tạm thời hoặc vĩnh viễn, tùy theo quyết định của ALPHA SPACEZ và yêu cầu đối
              tác phải bồi thường các thiệt hại phát sinh cho ALPHA SPACEZ.
            </p>
            <p>
              9.5 Để làm rõ, nghĩa vụ bảo mật thông tin quy định tại Mục này vẫn tiếp tục có hiệu
              lực ngay cả khi Quý Đối Tác và ALPHA SPACEZ chấm dứt hợp tác và/hoặc Tài Khoản Người
              Dùng của Quý Đối Tác bị chấm dứt hoạt động trên Ứng Dụng.
            </p>
          </div>

          <h3 className="font-bold text-gray-800 mt-4 mb-2">10. Trách nhiệm của Quý Đối Tác</h3>
          <div className="pl-4 md:pl-8 space-y-2 mb-4 text-gray-700">
            <p>
              10.1 Thực hiện Dịch Vụ và đảm bảo đúng tiến độ, đảm bảo tất cả sản phẩm sáng tạo do
              Quý Đối Tác thực hiện trong phạm vi Dịch Vụ phải được gửi cho ALPHA SPACEZ duyệt trước
              khi đăng tải, công bố.
            </p>
            <p>
              10.2 Đảm bảo giữ gìn hình ảnh cá nhân, không tạo dư luận xấu (scandal), không đưa ra
              bất cứ phát ngôn nào về ALPHA SPACEZ và/hoặc Nhãn hàng nếu chưa được ALPHA SPACEZ đồng
              ý.
            </p>
            <p>
              10.3 Không sử dụng sản phẩm sáng tạo đã thực hiện trong phạm vi Dịch Vụ vào bất cứ mục
              đích nào khác.
            </p>
            <p>10.4 Các nghĩa vụ liên quan đến phạm vi Dịch Vụ cụ thể:</p>
            <div className="pl-4 md:pl-8">
              <p>(a) Dịch Vụ đăng bài quảng cáo:</p>
              <ul className="list-disc pl-5">
                <li>
                  Đăng tải đúng nội dung, hình ảnh, thời gian và nền tảng mạng xã hội đã thỏa thuận.
                </li>
                <li>
                  Duy trì sản phẩm sáng tạo đã đăng tải công khai và vĩnh viễn, hoặc trong thời hạn
                  tối thiểu hai Bên đã thống nhất (nếu có). Trường hợp ALPHA SPACEZ phát hiện bài
                  đăng bị xóa hoặc ẩn, Quý Đối Tác có nghĩa vụ đăng lại bài đăng mà không yêu cầu
                  ALPHA SPACEZ thanh toán thêm Phí Dịch Vụ.
                </li>
                <li>
                  Chịu trách nhiệm về quyền sở hữu trí tuệ đối với các tác phẩm âm nhạc, hình ảnh,
                  nội dung được Quý Đối Tác sử dụng để thực hiện Dịch Vụ (nếu có).
                </li>
              </ul>
              <p className="mt-2">
                (b) Dịch Vụ cấp quyền sử dụng hình ảnh: đảm bảo trong thời hạn cấp quyền sử dụng
                hình ảnh sẽ không thực hiện quảng cáo, truyền thông cho bất cứ đối thủ cạnh tranh
                nào của Nhãn hàng, chi tiết về việc cấp quyền sử dụng hình ảnh (như: thời hạn, phạm
                vi, nền tảng...) sẽ được thỏa thuận và thống nhất bằng văn bản hoặc email.
              </p>
              <p className="mt-2">(c) Dịch Vụ sản xuất đoạn phim:</p>
              <ul className="list-disc pl-5">
                <li>
                  Thực hiện theo các yêu cầu về nội dung, thời lượng, định dạng, tiến độ, và các yếu
                  tố khác theo thống nhất giữa các Bên.
                </li>
                <li>
                  Cam kết đoạn phim hoàn chỉnh cung cấp hoặc thực hiện cho ALPHA SPACEZ chưa được
                  công bố trên bất kỳ nền tảng nào.
                </li>
                <li>
                  Chịu trách nhiệm về quyền sở hữu trí tuệ đối với các tác phẩm âm nhạc, hình ảnh,
                  nội dung được Quý Đối Tác sử dụng để thực hiện Dịch Vụ (nếu có).
                </li>
              </ul>
            </div>
            <p>
              10.5 Trường hợp được ALPHA SPACEZ cung cấp vật phẩm, sản phẩm, thiết bị, công cụ để
              thực hiện Dịch Vụ, Quý Đối Tác có trách nhiệm bảo quản các tài sản này và hoàn trả lại
              cho ALPHA SPACEZ ngay sau khi hoàn thành Dịch Vụ nếu ALPHA SPACEZ có yêu cầu hoàn trả.
              Quý Đối Tác chịu trách nhiệm bồi thường thiệt hại cho ALPHA SPACEZ nếu Quý Đối Tác làm
              mất mát, hư hỏng các tài sản này. Giá trị bồi thường thiệt hại sẽ theo quyết định của
              ALPHA SPACEZ và có thể được ALPHA SPACEZ cấn trừ trực tiếp vào Phí Dịch Vụ của Quý Đối
              Tác.
            </p>
            <p>
              10.6 Nếu Quý Đối Tác tự ý hủy một phần hay toàn bộ Dịch Vụ mà không phải do lỗi của
              ALPHA SPACEZ, Quý Đối Tác sẽ phải:
            </p>
            <div className="pl-4 md:pl-8">
              <p>
                (a) hoàn trả cho ALPHA SPACEZ (i) tất cả các khoản tạm ứng mà ALPHA SPACEZ đã thanh
                toán trước cho Quý Đối Tác (nếu có); và (ii) tất cả sản phẩm, công cụ, dụng cụ,
                thiết bị mà ALPHA SPACEZ cung cấp cho Quý Đối Tác để thực hiện Dịch Vụ (nếu có), nếu
                không hoàn trả được bằng hiện vật thì hoàn trả bằng tiền dựa trên giá trị niêm yết
                của sản phẩm đó (giá do Nhãn hàng niêm yết tại thời điểm ALPHA SPACEZ bàn giao sản
                phẩm cho Quý Đối Tác);
              </p>
              <p>
                (b) chịu mức phạt 5% trên tổng giá trị Dịch Vụ bị hủy hoặc một mức phạt khác do
                ALPHA SPACEZ quyết định tùy từng thời điểm;
              </p>
              <p>
                (c) bồi thường tất cả những thiệt hại phát sinh do việc hủy Dịch Vụ gây ra (bao gồm
                nhưng không giới hạn: chi phí bồi thường cho bên thứ ba liên quan, chi phí chênh
                lệch phải chi trả cho bên thứ ba khác để thay thế cho Quý Đối Tác thực hiện Dịch
                Vụ).
              </p>
            </div>
            <p>
              10.7 Các quyền và nghĩa vụ khác được thống nhất bởi các bên trong quá trình thực hiện
              Dịch Vụ.
            </p>
          </div>
        </section>
      </div>
    </div>
  )
}

export default TermsPage
